import BoxBackground from "./BoxBackground";

export default BoxBackground;
export { BoxBackground };
